var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-field-date-picker',{attrs:{"label":_vm.$t('commonStrings.date'),"allowed-dates":_vm.allowedDates,"disabled":_vm.disabled},on:{"input":function($event){return _vm.resetClaim(_vm.claim)}},model:{value:(_vm.claim.date),callback:function ($$v) {_vm.$set(_vm.claim, "date", $$v)},expression:"claim.date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }